import { Box, Paper, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';

interface Props {
  sx?: any;
  title: string;
  width: string;
}

const WsPanel = (props: PropsWithChildren<Props>) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 3,
        padding: 1,
      }}
    >
      <Typography color="primary" variant="h5">
        {props.title}
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          backgroundColor: '#f6f6f6',
          marginTop: 1,
          padding: 3,
          width: props.width,
          maxWidth: props.width,
          ...props.sx,
        }}
      >
        {props.children}
      </Paper>
    </Box>
  );
};

export default WsPanel;
